function isWithinWorkingHours(date = new Date()) {
  const dayOfWeek = date.getDay();
  const hours = date.getHours();
  const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
  const isWithinHours = hours >= 8 && hours < 18;

  return isWeekday && isWithinHours;
}

function toggleContactRibbon() {
  const contactRibbon = document.querySelector("#contactribbon");

  if (!contactRibbon) {
    return;
  }

  if (!isWithinWorkingHours()) {
    contactRibbon.style.display = "none";
  }
}

export { toggleContactRibbon };
